<template>
  <div id="app">
    <b-modal
    size="lg"
    ref="modal"
     hide-header-close
      hide-footer
      id="modal-manage-cookies"
      :no-close-on-backdrop="true"
      title="Manage cookies settings"
       >
       <b-row><b-col>
         <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="necessaryCookies"
                      disabled
                    >
                      I accept the use of necessary cookies.
                    </b-form-checkbox>
         </b-col></b-row>
       <b-row><b-col>
         <b-form-checkbox
                      checked-value="true"
                      unchecked-value="false"
                      v-model="analyticsEnabled"
                    >
                      I accept the use of cookies for analytics purposes.
                    </b-form-checkbox>
         </b-col></b-row>
         <br>
         <b-row><b-col cols="9">
   <!-- <b-button style="width:100%" variant="outline-success" @click="rejectAnalyticsCookies()">Deactivate Analytics Cookies</b-button>  -->
   </b-col>
         <b-col cols="3">
           <b-button style="width:100%" variant="success" @click="saveAgreementTimeAndSettings()">Ok</b-button>
           </b-col></b-row>
        </b-modal>
    <b-modal
    size="lg"
     hide-header-close
    ref="modal"
      hide-footer
      id="modal-cookies"
      :no-close-on-backdrop="true"
      title="Cookies on Culture Labs"
       >
       <div>
         Cookies allow a number of functions that enhance your experience on the website.
By using this website, you agree to the use of cookies, in accordance with the
<a target="_blank"   href="../static/CookiesPolicy.pdf">Personal Data Protection Policy</a>
.

         </div>
         <br>
         <b-row><b-col>
   <b-button style="width:100%"  variant="outline-success" @click="showManageCookingsModal()">Manage Settings</b-button>

         </b-col>
         <b-col>
           <b-button style="width:100%" variant="success" @click="saveAgreementTimeAndSettings()">Accept All</b-button>
           </b-col></b-row>

    </b-modal>
   <Navbar v-bind:project="project"></Navbar>
    <sidebar-menu :collapsed="true" v-if="authenticatedUser"
      style="position: fixed;
      top: 80px;
      height: calc(100% - 80px);
      width: 12%;
      min-width: 54px;
      z-index:1022;"
      :menu="menu"/>
    <router-view/>
    <Footer v-bind:project="project"></Footer>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Vuetify from 'vuetify'

export default {
  name: 'app',
  vuetify: new Vuetify(),
  components: {
    Navbar,
    Footer
  },
  methods:{

    showManageCookingsModal(){
      this.$bvModal.show('modal-manage-cookies');
    },
    saveAgreementTimeAndSettings(){
      if(this.analyticsEnabled){
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1210881355918811');
        fbq('track', 'PageView');
      }
      if(!this.analyticsEnabled){

        window['ga-disable-UA-162549109-1'] = true
      }


      let currentTime = Math.floor(Date.now() / 1000)
    console.log(currentTime)
       localStorage.setItem("latestCookiesAgreementTime", currentTime)
       localStorage.setItem("CulturelabsCookiesSettings", this.analyticsEnabled)
       this.$bvModal.hide('modal-cookies');
       this.$bvModal.hide('modal-manage-cookies');
    }
  }
  ,
  mounted(){
    let cookiesExpirationPeriod =  14400



    let CookiesAgreementExpirationTime = parseInt(localStorage.getItem("latestCookiesAgreementTime")) + cookiesExpirationPeriod
    console.log(CookiesAgreementExpirationTime)
    if(!CookiesAgreementExpirationTime){CookiesAgreementExpirationTime = 1}
    let currentTime = Math.floor(Date.now() / 1000)
    if(currentTime>CookiesAgreementExpirationTime){
    this.$bvModal.show('modal-cookies');
    }else if( localStorage.getItem("CulturelabsCookiesSettings") === "false"){
      this.analyticsEnabled = false
       if(this.analyticsEnabled){
        !function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
            n.callMethod ?
                n.callMethod.apply(n, arguments) : n.queue.push(arguments)
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s)
        }(window, document, 'script',
            'https://connect.facebook.net/en_US/fbevents.js');
        fbq('init', '1210881355918811');
        fbq('track', 'PageView');
      }
      if(!this.analyticsEnabled){

        window['ga-disable-UA-162549109-1'] = true
      }

    }
  },

  data () {
    return {
      necessaryCookies : true,
      analyticsEnabled: true,
      project: {
        'brandName': 'CultureLabs',
        'baseUrl': 'https://culture-labs.eu',
        'apiUrl': 'https://api.culture-labs.eu'
      },
      menu: [
        {
          header: true,
          title: 'Main Navigation',
          hiddenOnCollapse: true
        },
        {
          href: '/',
          title: 'Home',
          icon: 'fa fa-home'
        },
        {
          href: '/workspace/recipes',
          title: 'Recipes',
          icon: 'fa fa-concierge-bell'
        },
        {
          href: '/workspace/resources',
          title: 'Ingredients',
          icon: 'fa fa-utensils'
        },
        {
          href: '/workspace/organizations',
          title: 'Organisations',
          icon: 'fa fa-building'
        },
        // {
        //   header: true,
        //   title: 'Other',
        //   hiddenOnCollapse: false
        // },
        {
          href: '/workspace/groups',
          title: 'Groups',
          icon: 'fa fa-users'
        },
        {
          href: '/workspace/bookmarks',
          title: 'Bookmarks',
          icon: 'fas fa-bookmark'
        }
        // {
        //   href: '/workspace/account',
        //   title: 'My profile',
        //   icon: 'fa fa-user'
        // }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'authenticatedUser'
    ])
  }
}
</script>

<style>
  .btn-danger, .btn-info, .btn-dark, .btn-success, .btn-secondary {
    border-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue